// extracted by mini-css-extract-plugin
module.exports = {"root":"RichTextEditor_root__78GsP","error":"RichTextEditor_error__D9lJo","editor":"RichTextEditor_editor__pIwZO"};